import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const editIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M3.837 44.994L0 64l19.007-3.832L64 15.174 48.827 0 3.837 44.994zm12.538 10.262l-9.551 1.93 1.922-9.557 7.63 7.627zm40.081-40.087l-36.31 36.316-7.627-7.63 28.866-28.87 7.589 7.59 3.77-3.772-7.589-7.59 3.672-3.671 7.63 7.627z"/></svg>`
);
